export interface Student {
  version: number;
  id: string;
  createdAt: number;
  updatedAt: number;
  studentFirstName: string;
  studentSurname: string;
  spellcastUsername: string;
  password: string;
  createdBy: string;
  onboardingCompleted: boolean;
  level: number;
  mapsCompleted: number;
  levelsProgress: LevelProgress[];
  lastMasteredGame: string | null;
  characterInventory: CharacterInventory;
  scopeAndSequenceVersion: string;
  organisationId: string;
  settings: GameSettings;
  assessmentId: string | null; // null if not marked for assessment
  customLevelId: string | null; // null if no custom level assigned
  dailyActivities: DailyActivitiesState;
  tutorialization: TutorializationState;
  lastLogin: number; // timestamp of last login
  dev?: boolean; // whether the student is a developer
}

export interface TutorializationState {
  instructionsViewed: number[];
  biomesVisited: number[];
  hasViewedHudWalkthrough: boolean;
  hasViewedDuelWalkthrough: boolean;
}

// Levels Progress
export interface LevelProgress {
  levelId: string;
  completedPlaythroughs: number;
  gamesProgress: {
    [gameName: string]: GameProgress;
  };
}
export interface GameProgress {
  timesPlayed: number;
  timesMastered: number;
  currentHighestMastery: number;
  completedAtNodeIndex: number; // -1 if not completed
}

// Settings

export enum ControllerType {
  DRAG = 'drag',
  CLICK = 'click',
  KEYBOARD = 'keyboard',
}
export interface VoiceSettings {
  accent: 'AUS' | 'USA';
  gender: 'male' | 'female';
}
export interface GameSettings {
  version: number;
  playPhonemeOnCardDrop: boolean;
  wordLimit: number;
  controllerType: ControllerType;
  audio: AudioSettings;
  voice: VoiceSettings;
  wordSegmentationEnabled: boolean;
  duelsEnabled: boolean;
  distractorCardsEnabled: boolean;
  articulatoryGesturesEnabled: boolean;
}

export enum AudioDelay {
  SHORT = 250,
  MEDIUM = 500,
  LONG = 1000,
}

interface AudioSettings {
  masterVolume: number;
  sfxVolume: number;
  instructionsVolume: number;
  musicOn: boolean;
  sfxOn: boolean;
  audioDelay: AudioDelay;
}

// Character
export interface CharacterInventory {
  coins: number;
  unlockedItems: number[];
  equippedItems: EquipmentConfiguration;
  newItems: number[];
}

export interface EquipmentConfiguration {
  complexion: number | null;
  hats: number | null;
  hair: number | null;
  clothes: number | null;
  pants: number | null;
  shoes: number | null;
  face: number | null;
  gloves: number | null;
  back: number | null;
}

export interface Customization {
  id: number;
  name: string;
  texturePath: string;
  slot: string;
  tier?: number;
  price?: number;
  hidesSlots?: number[];
  disable?: boolean;
  gender?: 'm' | 'f';
}

export interface RarityTier {
  tier: number;
  name: string;
  color: string;
  price: number;
}

// Daily Activities
export interface DailyActivitiesState {
  minigames: {
    numCompletedMinigames: number;
    targetNumMinigames: number;
    numRewardsClaimed: number;
  };
  duel: {
    shouldCompleteDuel: boolean;
    hasCompletedDuel: boolean;
    hasClaimedDuelReward: boolean;
  };
  hasClaimedDailyReward: boolean; // Meta reward for all activities.
  hasViewedDailyActivities: boolean;
  lastRefresh: number;
}
